// Help text for: Notifications page.
// Keys are referenced as "notifications.<field>" by <FieldHelp id=... />. Entry shape:
//   title  - field name as shown on screen
//   use    - what the field is for / how to read it
//   source - measured | calculated | backend | default | setting | input
//   how    - where the value comes from: formula, default value, or who sets it
const help = {
  alerts: {
    title: "Alerts",
    use: "Machine alerts raised for your site, newest first, for the machines your login can see.",
    source: "backend",
    how: "Once a minute the last hour of breaker readings is checked against each machine's alert settings in Settings > Node Settings — rated power, working hours and the three alert switches. This screen shows up to the 200 newest alerts.",
  },
  alertsPanel: {
    title: "Alerts",
    use: "A quick look at your open alerts, followed by the 5 newest alerts that are already closed. Click one to open the full Notifications screen.",
    source: "backend",
    how: "Fetched fresh each time you open the panel. Alerts come from the same minute-by-minute checks against each machine's alert settings in Settings > Node Settings.",
  },
  allAlerts: {
    title: "All",
    use: "Every alert here, of any kind, open or closed. The number is how many.",
    source: "calculated",
    how: "Counts the alerts loaded on this screen, up to the 200 newest.",
  },
  powerExceeded: {
    title: "Power Exceeded",
    use: "The machine pulled more power than it is rated for, so its health reads Critical.",
    source: "backend",
    how: "Raised when a new reading at its breaker goes above the Rated Power (kW) you entered and \"Alert if rated power exceeded\" is switched on in Node Settings. The message shows the peak as a % of rated power. It closes itself once the newest reading is back at or below rated power.",
  },
  outsideHours: {
    title: "Outside Working Hours",
    use: "The machine kept running outside its working hours.",
    source: "backend",
    how: "Raised when the breaker shows more than 0.5 kW outside the machine's Working Hours, without a break, for the number of minutes you set — 15 unless you change it — and \"Alert if active outside hours\" is switched on. It closes itself when the machine drops below 0.5 kW or working hours begin.",
  },
  inactiveDuringHours: {
    title: "Inactive During Hours",
    use: "The machine sat switched off or idle during its working hours.",
    source: "backend",
    how: "Raised when the breaker shows less than 0.5 kW inside the machine's Working Hours, without a break, for the number of minutes you set — 15 unless you change it — and \"Alert if inactive during hours\" is switched on. It closes itself when the machine reaches 0.5 kW or working hours end.",
  },
  otherAlert: {
    title: "Alert",
    use: "An alert of a kind this screen does not label on its own, such as a Critical health alert sent to the mobile app.",
    source: "backend",
    how: "A Critical health alert is written down when a machine that is running — at least 0.5 kW at its breaker — has its newest reading go above its rated power. These never close on their own, so mark them resolved once you have dealt with them.",
  },
  severity: {
    title: "Severity",
    use: "How urgent the alert is.",
    source: "default",
    how: "Fixed by the kind of alert: Power Exceeded = High, Outside Working Hours = Warning, Inactive During Hours = Inactive, anything else = Info. It cannot be changed.",
  },
  resolved: {
    title: "Resolved",
    use: "This alert is closed: either the problem went away or someone closed it by hand.",
    source: "backend",
    how: "Closed on its own when the machine goes back to normal (see Reason), or when someone clicks Resolve. If the problem happens again, a fresh alert is raised.",
  },
  resolvedReason: {
    title: "Reason",
    use: "Why the alert was closed.",
    source: "backend",
    how: "Machine turned off, Machine turned on, Back in working hours, Working hours ended and Power back to normal all come from the minute-by-minute checks. Resolved by user means someone clicked Resolve.",
  },
  resolvedAt: {
    title: "Resolved time",
    use: "How long ago the alert was closed.",
    source: "backend",
    how: "Stamped with the time of the newest reading EnViz holds for your site — that applies whether the alert closed on its own or someone clicked Resolve, so it is not the moment of the click. Shown as minutes, hours or days ago, and as a date once it is more than 7 days old.",
  },
  alertTime: {
    title: "Alert time",
    use: "When the problem was spotted.",
    source: "backend",
    how: "The time of the reading that set the alert off: the highest reading for Power Exceeded, the newest reading for the other kinds. Shown as minutes, hours or days ago, and as a date once it is more than 7 days old.",
  },
  resolveAction: {
    title: "Resolve",
    use: "Close this alert yourself once you have dealt with it.",
    source: "input",
    how: "Marks it Resolved by user for everyone on your account. To stop it repeating, the same alert for this machine will not be raised again until the machine has gone back to normal at least once.",
  },
};

export default help;
